// @flow

import * as request from 'app/utils/request';
import * as urls from 'app/urls';

export const requestVersionAcceptanceFetcher = ({
  object_id,
  content_type,
  message,
  user_ids,
}: {
  object_id: number,
  content_type: string,
  message: string,
  user_ids: Array<string>,
}) =>
  request.postJson(urls.ACCEPTANCE_API_URL, {
    object_id,
    content_type,
    message,
    user_ids,
  });
